import { isResource } from '@medplum/core'
import { codeableConcept, hasCodeableConcept } from '#src/codeableConcept.ts'
import { LIBRARY_TOPIC } from '#src/codeSystems.ts'
import {
  CompositionLibraryEncoded,
  type LibrarySection,
} from '#src/models/compositionLibraryEncoded.ts'
import type { QueryTypes } from '#src/search.ts'
import { isOfType } from '#src/utils.ts'

export class IncidentTemplate extends CompositionLibraryEncoded {
  constructor(
    data?: ConstructorParameters<typeof CompositionLibraryEncoded>[0]
  ) {
    super({
      topic: [IncidentTemplate.libraryTopic],
      ...data,
    })
  }

  static searchQuery(): QueryTypes {
    return {
      topic: IncidentTemplate.libraryTopic,
      status: 'active',
      _sort: '-_lastUpdated',
    }
  }

  get sections(): IncidentTemplateSection[] {
    return this.getSections<IncidentTemplateSection>()
  }

  set sections(sections: IncidentTemplateSection[]) {
    this.setSections(sections)
  }

  static libraryTopic = codeableConcept({
    system: LIBRARY_TOPIC,
    code: 'incident',
    display: 'Incident',
  })

  static isInstance(value: unknown): value is IncidentTemplate {
    return (
      isResource(value) &&
      isOfType(value, 'Library') &&
      hasCodeableConcept(value.topic, IncidentTemplate.libraryTopic)
    )
  }
}

export interface IncidentTemplateSection extends LibrarySection {}
